import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EnvService } from "../core/env.service";
import { map } from "rxjs/operators";
import { ProjectData } from "src/app/models/api/projectdata";
import { ProjectUser } from "src/app/models/api/projectuser";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
  providedIn: "root",
})
export class ProjectsService {
  url = "unset";
  token =
    "bf1f05d97ff27d471a91215990f625ff73e1670688df4b7110e97b072d83f892de5e0bdb2f7b38070aaab1aced161c4509153f486fcb08dfa4dbd223e8acd5d285356c673c8e39339f2e17fb64c50013973ed7d68bbee492e15c6ad6b81537a161403b5f633206e20f37e106c9b5886fa21c0d07510a7496db229196d20d84d9";
  constructor(
    private http: HttpClient,
    private env: EnvService
  ) {
    this.url = this.env.strapiServer + "/strapi/api/";
    console.log("StrapiService", this.url);
  }

  /* projects */
  getProjects(page = 1, pageSize = 25) {
    return this.http.get<any>(
      this.url +
        `projects?pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      this.getHeader()
    );
  }

  getAllProjects() {
    return this.http.get<any>(
      this.url + "projects?populate=*",
      this.getHeader()
    );
  }

  getProjectById(id: number) {
    return this.http.get<any>(
      this.url + "projects/" + id + "?populate=*",
      this.getHeader()
    );
  }

  addProject(plant: any) {
    return this.http.post<any>(
      this.url + "projects/",
      { data: plant },
      this.getHeader()
    );
  }

  updateProject(plant: any) {
    return this.http.put<any>(
      this.url + "projects/" + plant.id + "?populate=*",
      { data: plant },
      this.getHeader()
    );
  }

  deleteProject(id: number) {
    return this.http.delete<any>(this.url + "projects/" + id, this.getHeader());
  }

  getHeader() {
    return {
      headers: new HttpHeaders({
        Authorization: `bearer ${this.token}`,
        "Content-Type": "application/json",
      }),
    };
  }

  filterProjects(searchWord: string, page = 1, pageSize = 10) {
    return this.http.get<any>(
      this.url +
        `projects?filters[$or][0][project_name][$containsi]=${searchWord}&filters[$or][1][customer][name][$containsi]=${searchWord}&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`,
      this.getHeader()
    );
  }

  filterProjectsNeoContactNotConfigured() {
    return this.http.get<any>(
      this.url + `projects?populate=*&filters[neo_contacts][$notNull]`,
      this.getHeader()
    );
  }

  filterProjectsNeoContactNotConfiguredList(page, pageSize) {
    return this.http.get<any>(
      this.url +
        `projects?populate=*&filters[neo_contacts][$notNull]&pagination[page]=${page}&pagination[pageSize]=${pageSize}`,
      this.getHeader()
    );
  }

  /**
   * Get project by Plant Code
   * @param plantCode The plant code to filter projects
   */
  getProjectByPlantCode(plantCode: string): Observable<ProjectData> {
    return this.http
      .get<any>(
        `${
          this.url
        }projects?filters[plant][plantCode][$eq]=${encodeURIComponent(
          plantCode
        )}&populate=deep`,
        this.getHeader()
      )
      .pipe(map((response) => response.data[0] as ProjectData));
  }

  getProjectByPlantCodeNoDeep(plantCode: string): Observable<ProjectData> {
    return this.http
      .get<any>(
        `${
          this.url
        }projects?filters[plant][plantCode][$eq]=${encodeURIComponent(
          plantCode
        )}`,
        this.getHeader()
      )
      .pipe(map((response) => response.data[0] as ProjectData));
  }

  /**
   * Get only neo_contacts from a project by Plant Code
   * @param plantCode The plant code to filter projects
   */
  getNeoContactsByPlantCode(plantCode: string): Observable<ProjectUser[]> {
    return this.getProjectByPlantCode(plantCode).pipe(
      map((project) => project.attributes.neo_contacts.data)
    );
  }

  getPRWarrantyByPlantCodeYear(plantCode: string, year: string) {
    return this.http.get<any>(
      this.url +
        `plant-monthly-factor-configurations?filters[$and][0][plant_station_code][$eq]=${encodeURIComponent(
          plantCode
        )}&filters[$and][1][year][$eq]=${year}&pagination[page]=1&pagination[pageSize]=1`,
      this.getHeader()
    );
  }

  getPRWarrantyByPlantCodeBeforeDate(plantCode: string, date: string) {
    // const isoDate = date.toISOString(); // e.g. '2023-11-21T12:00:00.000Z'

    return this.http.get<any>(
      this.url +
        `plant-monthly-factor-configurations?` +
        `filters[$and][0][plant_station_code][$eq]=${encodeURIComponent(plantCode)}` +
        `&filters[$and][1][period][$lte]=${encodeURIComponent(date)}` +
        `&sort[0]=period:desc` +
        `&pagination[page]=1&pagination[pageSize]=1`,
      this.getHeader()
    );
  }
}
